// API 유틸리티 - 표준화된 요청/응답 처리
import instance, { ApiResponse } from '../apis/instance';

interface RequestOptions {
  timeout?: number;
  retries?: number;
}

export const apiRequest = {
  get: async <T = any>(url: string, options?: RequestOptions): Promise<ApiResponse<T>> => {
    try {
      const response = await instance.get(url, {
        timeout: options?.timeout || 10000
      });
      return response as unknown as ApiResponse<T>;
    } catch (error: any) {
      console.error(`GET ${url} 실패:`, error);
      return {
        success: false,
        message: error.message || 'API 요청 실패',
        data: null,
        error: error.message
      };
    }
  },

  post: async <T = any>(url: string, data?: any, options?: RequestOptions): Promise<ApiResponse<T>> => {
    try {
      const response = await instance.post(url, data, {
        timeout: options?.timeout || 10000
      });
      return response as unknown as ApiResponse<T>;
    } catch (error: any) {
      console.error(`POST ${url} 실패:`, error);
      return {
        success: false,
        message: error.message || 'API 요청 실패',
        data: null,
        error: error.message
      };
    }
  },

  put: async <T = any>(url: string, data?: any, options?: RequestOptions): Promise<ApiResponse<T>> => {
    try {
      const response = await instance.put(url, data, {
        timeout: options?.timeout || 10000
      });
      return response as unknown as ApiResponse<T>;
    } catch (error: any) {
      console.error(`PUT ${url} 실패:`, error);
      return {
        success: false,
        message: error.message || 'API 요청 실패',
        data: null,
        error: error.message
      };
    }
  },

  delete: async <T = any>(url: string, options?: RequestOptions): Promise<ApiResponse<T>> => {
    try {
      const response = await instance.delete(url, {
        timeout: options?.timeout || 10000
      });
      return response as unknown as ApiResponse<T>;
    } catch (error: any) {
      console.error(`DELETE ${url} 실패:`, error);
      return {
        success: false,
        message: error.message || 'API 요청 실패',
        data: null,
        error: error.message
      };
    }
  }
};

export default apiRequest;
